import PropTypes from "prop-types";
import CuentaCorrienteModal from "../components/CuentaCorrienteModal";

export default function ModalCuentaCorriente({ open, handleClose, selected }) {
  return <CuentaCorrienteModal open={open} handleClose={handleClose} selected={selected} />;
}

ModalCuentaCorriente.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  selected: PropTypes.object,
};
